import { NavLink } from "react-router-dom"
import styled from "styled-components"

const Container = styled.div`

  .navlink{
    padding: 10px;
    font-size: 16px;
    font-weight: var(--font-weight-lg);
    line-height: 18px;
    text-align: center;
    border: 1px solid;
    border-color: ${({ theme }) => theme.mainBorderColor};
    color: ${({ theme }) => theme.mainTextColor};
    border-radius: 10px;

    &:hover{
      border-color: ${({ theme }) => theme.contrastColor};
    }
  }
  
  .active{
      border-color: var(--color-main) !important;
      color: var(--color-main) !important;
      background-color: ${({ theme }) => theme.mainBgColor};

  }

`

const PageSubLinkItem = ({item}) => {

  return (
    <Container>
      <NavLink end className={({isActive})=> isActive ? "active navlink": "navlink"} to={item.slug}>
        {item.description}
      </NavLink>
    </Container>
  )
}

export default PageSubLinkItem